import React from 'react';

import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {getFeatureStatus} from 'auth/feature-enablement/FeatureStatus';
import {AlignmentSummary} from 'constants/AlignmentConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
import {isProteinAlignment} from 'molbio/AlignmentUtil';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface AlignmentSidepanelItemProps {
  active: boolean;
  isCompact: boolean;
  alignmentSummary: AlignmentSummary;
  isChild: boolean;
}

export default function AlignmentSidepanelItem({
  active,
  isCompact,
  alignmentSummary,
  isChild,
}: AlignmentSidepanelItemProps): JSX.Element {
  const {prefix, date} = FileBrowserUtil.getResultDate(alignmentSummary, {
    fuzzy: true,
    compact: isCompact,
  });
  const dateString = `${isCompact ? '' : prefix}${date}`;
  const featureStatus = getFeatureStatus({
    feature: StandardFeature.OPEN,
    item: alignmentSummary,
  });
  return (
    <SidepanelItem
      active={active}
      className="sidepanelItem--noIcon"
      faded={!featureStatus.enabled}
      icon={<BenchlingIcon icon="alignment" />}
      isCompact={isCompact}
      onClick={() => {
        if (isProteinAlignment(alignmentSummary)) {
          FileBrowserActions.openItem(alignmentSummary.protein.id, {
            alignment: alignmentSummary.id,
          });
        } else {
          FileBrowserActions.openItem(alignmentSummary.sequence.id, {
            alignment: alignmentSummary.id,
          });
        }
      }}
      showStar={false}
      starred={false}
      subTitle={dateString}
      title={{
        text: alignmentSummary.name,
        node: <AlignmentSidepanelTitle alignmentSummary={alignmentSummary} />,
      }}
      tooltipText={featureStatus.enabled ? '' : featureStatus.userMessage}
      isExpandable={false}
      isChild={isChild}
    />
  );
}

export function AlignmentSidepanelTitle(props: {alignmentSummary: AlignmentSummary}): JSX.Element {
  return (
    <span>
      <span className="sidepanel-primaryLabel">{props.alignmentSummary.name}</span>
      <span className="sidepanel-secondaryLabel">
        {' '}
        {isProteinAlignment(props.alignmentSummary) ? 'AA alignment' : 'DNA alignment'}
      </span>
    </span>
  );
}
